function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _decorate(decorators, factory, superClass, mixins) {
  var api = _getDecoratorsApi();

  if (mixins) {
    for (var i = 0; i < mixins.length; i++) {
      api = mixins[i](api);
    }
  }

  var r = factory(function initialize(O) {
    api.initializeInstanceElements(O, decorated.elements);
  }, superClass);
  var decorated = api.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), decorators);
  api.initializeClassElements(r.F, decorated.elements);
  return api.runClassFinishers(r.F, decorated.finishers);
}

function _getDecoratorsApi() {
  _getDecoratorsApi = function _getDecoratorsApi() {
    return api;
  };

  var api = {
    elementsDefinitionOrder: [["method"], ["field"]],
    initializeInstanceElements: function initializeInstanceElements(O, elements) {
      ["method", "field"].forEach(function (kind) {
        elements.forEach(function (element) {
          if (element.kind === kind && element.placement === "own") {
            this.defineClassElement(O, element);
          }
        }, this);
      }, this);
    },
    initializeClassElements: function initializeClassElements(F, elements) {
      var proto = F.prototype;
      ["method", "field"].forEach(function (kind) {
        elements.forEach(function (element) {
          var placement = element.placement;

          if (element.kind === kind && (placement === "static" || placement === "prototype")) {
            var receiver = placement === "static" ? F : proto;
            this.defineClassElement(receiver, element);
          }
        }, this);
      }, this);
    },
    defineClassElement: function defineClassElement(receiver, element) {
      var descriptor = element.descriptor;

      if (element.kind === "field") {
        var initializer = element.initializer;
        descriptor = {
          enumerable: descriptor.enumerable,
          writable: descriptor.writable,
          configurable: descriptor.configurable,
          value: initializer === void 0 ? void 0 : initializer.call(receiver)
        };
      }

      Object.defineProperty(receiver, element.key, descriptor);
    },
    decorateClass: function decorateClass(elements, decorators) {
      var newElements = [];
      var finishers = [];
      var placements = {
        "static": [],
        prototype: [],
        own: []
      };
      elements.forEach(function (element) {
        this.addElementPlacement(element, placements);
      }, this);
      elements.forEach(function (element) {
        if (!_hasDecorators(element)) return newElements.push(element);
        var elementFinishersExtras = this.decorateElement(element, placements);
        newElements.push(elementFinishersExtras.element);
        newElements.push.apply(newElements, elementFinishersExtras.extras);
        finishers.push.apply(finishers, elementFinishersExtras.finishers);
      }, this);

      if (!decorators) {
        return {
          elements: newElements,
          finishers: finishers
        };
      }

      var result = this.decorateConstructor(newElements, decorators);
      finishers.push.apply(finishers, result.finishers);
      result.finishers = finishers;
      return result;
    },
    addElementPlacement: function addElementPlacement(element, placements, silent) {
      var keys = placements[element.placement];

      if (!silent && keys.indexOf(element.key) !== -1) {
        throw new TypeError("Duplicated element (" + element.key + ")");
      }

      keys.push(element.key);
    },
    decorateElement: function decorateElement(element, placements) {
      var extras = [];
      var finishers = [];

      for (var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--) {
        var keys = placements[element.placement];
        keys.splice(keys.indexOf(element.key), 1);
        var elementObject = this.fromElementDescriptor(element);
        var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject);
        element = elementFinisherExtras.element;
        this.addElementPlacement(element, placements);

        if (elementFinisherExtras.finisher) {
          finishers.push(elementFinisherExtras.finisher);
        }

        var newExtras = elementFinisherExtras.extras;

        if (newExtras) {
          for (var j = 0; j < newExtras.length; j++) {
            this.addElementPlacement(newExtras[j], placements);
          }

          extras.push.apply(extras, newExtras);
        }
      }

      return {
        element: element,
        finishers: finishers,
        extras: extras
      };
    },
    decorateConstructor: function decorateConstructor(elements, decorators) {
      var finishers = [];

      for (var i = decorators.length - 1; i >= 0; i--) {
        var obj = this.fromClassDescriptor(elements);
        var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj);

        if (elementsAndFinisher.finisher !== undefined) {
          finishers.push(elementsAndFinisher.finisher);
        }

        if (elementsAndFinisher.elements !== undefined) {
          elements = elementsAndFinisher.elements;

          for (var j = 0; j < elements.length - 1; j++) {
            for (var k = j + 1; k < elements.length; k++) {
              if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) {
                throw new TypeError("Duplicated element (" + elements[j].key + ")");
              }
            }
          }
        }
      }

      return {
        elements: elements,
        finishers: finishers
      };
    },
    fromElementDescriptor: function fromElementDescriptor(element) {
      var obj = {
        kind: element.kind,
        key: element.key,
        placement: element.placement,
        descriptor: element.descriptor
      };
      var desc = {
        value: "Descriptor",
        configurable: true
      };
      Object.defineProperty(obj, Symbol.toStringTag, desc);
      if (element.kind === "field") obj.initializer = element.initializer;
      return obj;
    },
    toElementDescriptors: function toElementDescriptors(elementObjects) {
      if (elementObjects === undefined) return;
      return _toArray(elementObjects).map(function (elementObject) {
        var element = this.toElementDescriptor(elementObject);
        this.disallowProperty(elementObject, "finisher", "An element descriptor");
        this.disallowProperty(elementObject, "extras", "An element descriptor");
        return element;
      }, this);
    },
    toElementDescriptor: function toElementDescriptor(elementObject) {
      var kind = String(elementObject.kind);

      if (kind !== "method" && kind !== "field") {
        throw new TypeError('An element descriptor\'s .kind property must be either "method" or' + ' "field", but a decorator created an element descriptor with' + ' .kind "' + kind + '"');
      }

      var key = _toPropertyKey(elementObject.key);

      var placement = String(elementObject.placement);

      if (placement !== "static" && placement !== "prototype" && placement !== "own") {
        throw new TypeError('An element descriptor\'s .placement property must be one of "static",' + ' "prototype" or "own", but a decorator created an element descriptor' + ' with .placement "' + placement + '"');
      }

      var descriptor = elementObject.descriptor;
      this.disallowProperty(elementObject, "elements", "An element descriptor");
      var element = {
        kind: kind,
        key: key,
        placement: placement,
        descriptor: Object.assign({}, descriptor)
      };

      if (kind !== "field") {
        this.disallowProperty(elementObject, "initializer", "A method descriptor");
      } else {
        this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor");
        this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor");
        this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor");
        element.initializer = elementObject.initializer;
      }

      return element;
    },
    toElementFinisherExtras: function toElementFinisherExtras(elementObject) {
      var element = this.toElementDescriptor(elementObject);

      var finisher = _optionalCallableProperty(elementObject, "finisher");

      var extras = this.toElementDescriptors(elementObject.extras);
      return {
        element: element,
        finisher: finisher,
        extras: extras
      };
    },
    fromClassDescriptor: function fromClassDescriptor(elements) {
      var obj = {
        kind: "class",
        elements: elements.map(this.fromElementDescriptor, this)
      };
      var desc = {
        value: "Descriptor",
        configurable: true
      };
      Object.defineProperty(obj, Symbol.toStringTag, desc);
      return obj;
    },
    toClassDescriptor: function toClassDescriptor(obj) {
      var kind = String(obj.kind);

      if (kind !== "class") {
        throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator' + ' created a class descriptor with .kind "' + kind + '"');
      }

      this.disallowProperty(obj, "key", "A class descriptor");
      this.disallowProperty(obj, "placement", "A class descriptor");
      this.disallowProperty(obj, "descriptor", "A class descriptor");
      this.disallowProperty(obj, "initializer", "A class descriptor");
      this.disallowProperty(obj, "extras", "A class descriptor");

      var finisher = _optionalCallableProperty(obj, "finisher");

      var elements = this.toElementDescriptors(obj.elements);
      return {
        elements: elements,
        finisher: finisher
      };
    },
    runClassFinishers: function runClassFinishers(constructor, finishers) {
      for (var i = 0; i < finishers.length; i++) {
        var newConstructor = (0, finishers[i])(constructor);

        if (newConstructor !== undefined) {
          if (typeof newConstructor !== "function") {
            throw new TypeError("Finishers must return a constructor.");
          }

          constructor = newConstructor;
        }
      }

      return constructor;
    },
    disallowProperty: function disallowProperty(obj, name, objectType) {
      if (obj[name] !== undefined) {
        throw new TypeError(objectType + " can't have a ." + name + " property.");
      }
    }
  };
  return api;
}

function _createElementDescriptor(def) {
  var key = _toPropertyKey(def.key);

  var descriptor;

  if (def.kind === "method") {
    descriptor = {
      value: def.value,
      writable: true,
      configurable: true,
      enumerable: false
    };
  } else if (def.kind === "get") {
    descriptor = {
      get: def.value,
      configurable: true,
      enumerable: false
    };
  } else if (def.kind === "set") {
    descriptor = {
      set: def.value,
      configurable: true,
      enumerable: false
    };
  } else if (def.kind === "field") {
    descriptor = {
      configurable: true,
      writable: true,
      enumerable: true
    };
  }

  var element = {
    kind: def.kind === "field" ? "field" : "method",
    key: key,
    placement: def["static"] ? "static" : def.kind === "field" ? "own" : "prototype",
    descriptor: descriptor
  };
  if (def.decorators) element.decorators = def.decorators;
  if (def.kind === "field") element.initializer = def.value;
  return element;
}

function _coalesceGetterSetter(element, other) {
  if (element.descriptor.get !== undefined) {
    other.descriptor.get = element.descriptor.get;
  } else {
    other.descriptor.set = element.descriptor.set;
  }
}

function _coalesceClassElements(elements) {
  var newElements = [];

  var isSameElement = function isSameElement(other) {
    return other.kind === "method" && other.key === element.key && other.placement === element.placement;
  };

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    var other;

    if (element.kind === "method" && (other = newElements.find(isSameElement))) {
      if (_isDataDescriptor(element.descriptor) || _isDataDescriptor(other.descriptor)) {
        if (_hasDecorators(element) || _hasDecorators(other)) {
          throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated.");
        }

        other.descriptor = element.descriptor;
      } else {
        if (_hasDecorators(element)) {
          if (_hasDecorators(other)) {
            throw new ReferenceError("Decorators can't be placed on different accessors with for " + "the same property (" + element.key + ").");
          }

          other.decorators = element.decorators;
        }

        _coalesceGetterSetter(element, other);
      }
    } else {
      newElements.push(element);
    }
  }

  return newElements;
}

function _hasDecorators(element) {
  return element.decorators && element.decorators.length;
}

function _isDataDescriptor(desc) {
  return desc !== undefined && !(desc.value === undefined && desc.writable === undefined);
}

function _optionalCallableProperty(obj, name) {
  var value = obj[name];

  if (value !== undefined && typeof value !== "function") {
    throw new TypeError("Expected '" + name + "' to be a function");
  }

  return value;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import { LitElement, html, property } from 'lit-element';
import { unsafeSVG } from 'lit-html/directives/unsafe-svg';
import { until } from 'lit-html/directives/until.js';
import { defineElementSlot } from '@polleverywhere/element-helpers';
import { register } from '@polleverywhere/hmr-custom-element';
import { bemBlock } from '@polleverywhere/bem-helpers';
import './graphic.scss';
/**
 * List of all valid types that this element supports.
 * @type {Array}
 */

var validTypes = ['icon', 'illustration', 'text', 'legacy-glyph', 'legacy-svg'];
/**
 * Mapping of deprecated types and their equivalent aliases.
 * @type {Object}
 */

var deprecatedTypes = {
  glyph: 'icon',
  svg: 'illustration',
  graphic: 'illustration'
};
/**
 * Graphic element lets consumers easily render SVG icons, SVG illustrations,
 * text icons and legacy icon font glyphs. Consumers must provide both the
 * `type` and `name` of the icon to render. Omitting the `type` field implies
 * the `illustration` type by default. Text-based icons uses the first two
 * characters in `name` as the icon.
 *
 * ```
 * // Render illustrations, icons and text icons.
 * <pe-graphic name='my-illustration'></pe-graphic>
 * <pe-graphic type='icon' name='folder'></pe-graphic>
 * <pe-graphic type='text' name='da'></pe-graphic>
 *
 * // To render legacy illustrations and icon glyphs.
 * <pe-graphic type='legacy-svg' name='ok-green'></pe-graphic>
 * <pe-graphic type='legacy-glyph' name='anonymous'></pe-graphic>
 *
 * // Render custom SVGs that are stored within your own package b passing them
 * // in via default slot and setting `type=custom`.
 * <pe-graphic type='custom'>
 *   <svg id=arrow xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
 *     <path d="M22 27.109 10.804 16 22 4.891 20.598 3.5 8 16l12.598 12.5z"/>
 *   </svg>
 * </pe-graphic>
 *
 * // Apply custom colors to icons using CSS properties.
 * <pe-graphic style='--pe-graphic-color: blue' type='icon' name='folder'></pe-graphic>
 *
 * // Scale the graphic up or down using CSS properties.
 * <pe-graphic style='--pe-graphic-size: 2rem' name='blog'></pe-graphic>
 * ```
 *
 * @element pe-graphic
 *
 * @prop {string} [type=illustration] - Selects the type of graphic to render.
 *  Valid types are `icon`, `illustration`, `text`, `custom`, `legacy-svg`,
 *  `legacy-glyph`. DEPRECATED types are `graphic`, `svg`, `glyph` and act as
 *  aliases to `illustration` and `icon` respectively. Default type when field is
 *  omitted is `illustration`.
 * @prop {string} name - For `icon` and `illustration` types, this is the SVG
 *  file name. For text-based icons, the first two characters are used.
 *
 * @cssprop [--pe-graphic-color=pe-neutral-900] - Apply primary color to all
 *  icon types only. Graphic types do not support custom color settings.
 * @cssprop --pe-graphic-secondary-color - Apply a secondary color to all icons
 *  that support multiple colors to create duotone icons. Graphic types do not
 *  support custom color settings.
 * @cssprop --pe-graphic-size - Change the size of the graphic.
 *
 * @slot - When `type=custom`, pass in your own custom raw SVG which gets
 *  rendered by the element and lets you scale the SVG in a consistent way.
 */

var Graphic = _decorate(null, function (_initialize, _LitElement) {
  var Graphic = /*#__PURE__*/function (_LitElement2) {
    _inheritsLoose(Graphic, _LitElement2);

    function Graphic() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _LitElement2.call.apply(_LitElement2, [this].concat(args)) || this;

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return Graphic;
  }(_LitElement);

  return {
    F: Graphic,
    d: [{
      kind: "get",
      "static": true,
      key: "tagName",
      value: function tagName() {
        return 'pe-graphic';
      }
    }, {
      kind: "get",
      decorators: [property({
        type: String
      })],
      key: "type",
      value: function type() {
        return this._type || 'illustration';
      }
    }, {
      kind: "set",
      key: "type",
      value: function type(value) {
        var oldValue = this._type;
        if (value === oldValue) return;
        this._type = value;
        this.requestUpdate('type', oldValue);
      }
    }, {
      kind: "field",
      decorators: [property({
        type: String
      })],
      key: "name",
      value: void 0
    }, {
      kind: "method",
      key: "createRenderRoot",
      value: function createRenderRoot() {
        return this;
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(Graphic.prototype), "connectedCallback", this).call(this);

        defineElementSlot(this);
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        if (this.type in deprecatedTypes) {
          console.warn(this.tagName + "[name=" + this.name + "] has [type=" + this.type + "] and should be replaced with [type=" + deprecatedTypes[this.type] + "]");
        }

        return until(renderText.call(this) || renderLegacyGlyph.call(this) || renderSvg.call(this), html(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["<div class=", "></div>"])), bem('placeholder')));
      }
    }]
  };
}, LitElement);
/**
 * Returns a promise that resolves with the SVG template result or an empty
 * string if the type is not handled here. Raw SVG is fetched from different
 * paths depending on the type. Promise is rejected when SVG file is not found.
 * @return {Promise} Resolves to the SVG template result or an empty string if
 *  type is not supported. Rejects with an error if SVG import fails.
 */


export { Graphic as default };

function renderSvg() {
  return _renderSvg.apply(this, arguments);
}
/**
 * Renders a text-based icon with the first two letters of "name".
 */


function _renderSvg() {
  _renderSvg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var rawSvg, hasSvg, slots;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rawSvg = '';
            _context.t0 = this.type;
            _context.next = _context.t0 === 'custom' ? 4 : _context.t0 === 'svg' ? 9 : _context.t0 === 'graphic' ? 9 : _context.t0 === 'illustration' ? 9 : _context.t0 === 'glyph' ? 13 : _context.t0 === 'icon' ? 13 : _context.t0 === 'legacy-svg' ? 17 : 21;
            break;

          case 4:
            // Renders the SVG passed in via default slot. To support this with our
            // custom slots API, we have to iterate through each node and convert the
            // text node containing <svg> markup into legitimate SVG template results.
            hasSvg = false;
            slots = this.slots().map(function (node) {
              var isSvgNode = /^svg$/i.test(node.tagName);
              var isUnsafeSvgNode = /^<svg.*>.*<\/svg>$/.test(node.data);
              hasSvg = hasSvg || isSvgNode || isUnsafeSvgNode;
              return isUnsafeSvgNode ? unsafeSVG(node.data) : node;
            }); // Error check to ensure this type only renders SVGs passed into the slot.

            if (hasSvg) {
              _context.next = 8;
              break;
            }

            throw new Error(this.tagName + "[type=" + this.type + "] must have SVG content in its default slot but is missing");

          case 8:
            return _context.abrupt("return", slots);

          case 9:
            _context.next = 11;
            return import(
            /* webpackChunkName: 'illustration-[request]' */
            "./illustrations/" + this.name + ".svg");

          case 11:
            rawSvg = _context.sent["default"];
            return _context.abrupt("break", 22);

          case 13:
            _context.next = 15;
            return import(
            /* webpackChunkName: 'icon-[request]' */
            "./icons/" + this.name + ".svg");

          case 15:
            rawSvg = _context.sent["default"];
            return _context.abrupt("break", 22);

          case 17:
            _context.next = 19;
            return import(
            /* webpackChunkName: 'legacy-[request]' */
            "@polleverywhere/assets/icons/" + this.name + ".svg");

          case 19:
            rawSvg = _context.sent["default"];
            return _context.abrupt("break", 22);

          case 21:
            throw new Error(this.tagName + "[name=" + this.name + "] has invalid [type=" + this.type + "] and must be one of [" + validTypes.join(',') + "]");

          case 22:
            return _context.abrupt("return", rawSvg ? unsafeSVG(rawSvg) : '');

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _renderSvg.apply(this, arguments);
}

function renderText() {
  if (this.type !== 'text') return ''; // Uppercase first two letters of icon text to render into an icon.

  var initials = this.name.substring(0, 2).toUpperCase();
  return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  <div class=", " name='", "' aria-hidden='true'>\n    <span class=", ">", "</span>\n  </div>"])), bem('text'), initials, bem('text-label'), initials);
}
/**
 * Renders a legacy glyph template.
 */


function renderLegacyGlyph() {
  if (this.type !== 'legacy-glyph') return '';
  return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  <span class=", "\n      data-glyph='", "'\n      aria-hidden='true'></span>"])), bem('legacy-glyph'), this.name);
}

var bem = bemBlock(Graphic.tagName);
register(module, Graphic.tagName, Graphic);